/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.4.21",
    versionName: "0.2.0-nightly.2026.4.21",
    versionChannel: "nightly",
    buildDate: "2026-04-21T00:18:43.418Z",
    commitHash: "3de837a9eae907974260bcdd57974fa144bb3c7b",
};
